export interface LeaderboardEntry {
  id: string;
  nickname: string;
  score: number;
  createdAt: string;
}

export type LeaderboardRow = {
  id: string;
  nickname: string;
  score: number;
  created_at: string;
};

export const mapLeaderboardRow = (row: LeaderboardRow): LeaderboardEntry => ({
  id: row.id,
  nickname: row.nickname,
  score: row.score,
  createdAt: row.created_at,
});
